import React from 'react';

import {
  APISubscriptionDetails,
  GstAddress,
} from '../../components/sign-up/types';
import { SignupProductType, SolutionType } from '../api/types';

export enum SignUpStep {
  verifyEmail,
  selectPlan,
  orgDetails,
  contactAdmin,
  verifying,
  taxIndiaDetails,
  billingDetails,
  paymentDetails,
  settingUp,
  waitlisted,
  setupSuccess,
  setupFailed,
  paymentComplete,
}

export interface SignUpContextProps {
  currentStep: SignUpStep;
  signUpCustomerEmail: string | undefined;
  signUpCustomerCountry: string | undefined;
  requestId: string | undefined;
  formId: string | undefined;
  errorMessage: string | undefined;
  areOrgDetailsValid: boolean | undefined;
  areBillingDetailsValid: boolean | undefined;
  tierName: string | undefined;
  solutionId: string | undefined;
  gstAddress?: GstAddress;
  selectedSolutionType?: SolutionType;
  apiSubscriptionDetails?: APISubscriptionDetails[];
  setSignUpCustomerEmail: (email: string) => void;
  setSignUpStep: (step: SignUpStep) => void;
  setRequestId: (id: string) => void;
  setFormId: (id: string) => void;
  setSignUpCustomerCountry: (country: string) => void;
  setErrorMessage: (message: string) => void;
  setAreOrgDetailsValid: (isValid: boolean) => void;
  setAreBillingDetailsValid: (isValid: boolean) => void;
  cancelSignup: () => void;
  clearStateStorage: () => void;
  setGstAddress: (gstAddress?: GstAddress) => void;
  setSelectedSolutionType: (
    solutionType: SolutionType,
    type: SignupProductType
  ) => void;
  setApiSubscriptionDetails: (keys: APISubscriptionDetails[]) => void;
}

export const SignUpContext = React.createContext<SignUpContextProps | null>(
  null
);
